import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { EditorAnalyticsAPI } from '@atlaskit/editor-common/analytics';

import { editorAnalyticsAPI } from './tablePluginOptions';

export const getEditorAnalyticsAPI = (
	contentId,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
): EditorAnalyticsAPI => editorAnalyticsAPI.analyticsCallback(contentId, createAnalyticsEvent);
